import React, { useState } from "react";

const POSITION_CLASSES = {
  top: "bottom-full left-1/2 -translate-x-1/2 mb-1.5",
  bottom: "top-full left-1/2 -translate-x-1/2 mt-1.5",
  left: "right-full top-1/2 -translate-y-1/2 mr-1.5",
  right: "left-full top-1/2 -translate-y-1/2 ml-1.5",
};

/** Hover/focus tooltip. Wrap any inline content; pass the full text via `content`. */
function Tooltip({ content, children, position = "top", className = "" }) {
  const [visible, setVisible] = useState(false);

  if (!content) return children;

  return (
    <span
      className={`relative inline-flex min-w-0 ${className}`}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
    >
      {children}
      {visible && (
        <span
          role="tooltip"
          className={`pointer-events-none absolute z-50 max-w-xs whitespace-normal break-words rounded-md bg-gray-900 px-2.5 py-1.5 text-[11px] leading-snug text-white shadow-lg ${
            POSITION_CLASSES[position] || POSITION_CLASSES.top
          }`}
        >
          {content}
        </span>
      )}
    </span>
  );
}

export default Tooltip;
